import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuestion = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.66669 16C1.66669 8.08391 8.08394 1.66666 16 1.66666C23.9162 1.66666 30.3334 8.08391 30.3334 16C30.3334 23.9161 23.9162 30.3333 16 30.3333C8.08394 30.3333 1.66669 23.9161 1.66669 16ZM14.3334 13.3333C14.3334 12.4128 15.0795 11.6667 16 11.6667C16.9206 11.6667 17.6667 12.4128 17.6667 13.3333V13.4951C17.6667 13.98 17.474 14.4451 17.1311 14.788L15.293 16.6263C14.9024 17.0168 14.9024 17.6499 15.293 18.0404C15.6835 18.4309 16.3166 18.4309 16.7071 18.0404L18.5454 16.2023C19.2634 15.4843 19.6667 14.5104 19.6667 13.4951V13.3333C19.6667 11.3083 18.0251 9.66666 16 9.66666C13.975 9.66666 12.3334 11.3083 12.3334 13.3333V14C12.3334 14.5523 12.7811 15 13.3334 15C13.8856 15 14.3334 14.5523 14.3334 14V13.3333ZM16 19.6667C15.0795 19.6667 14.3334 20.4128 14.3334 21.3333C14.3334 22.2539 15.0795 23 16 23C16.9206 23 17.6667 22.2539 17.6667 21.3333C17.6667 20.4128 16.9206 19.6667 16 19.6667Z",
		fill: "currentColor"
	})
});
export default SvgQuestion;
